import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const DevtoolsRoutes = defineRoute({
    database: {
        route: {
            path: "/dev/database",
            component: () => loadView(import("./DevDatabaseHome.vue")),
        },
    },
    maintenance: {
        route: {
            path: "/dev/maintenance",
            component: () => loadView(import("./DevMaintenanceHome.vue")),
        },
    },
    mobile: {
        route: {
            path: "/dev/mobile",
            component: () => loadView(import("./DevMobileHome.vue")),
        },
    },
});
